import React from 'react'
import { Outlet } from 'react-router-dom'

const Producer = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default Producer